import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../store';
import * as styles from '../styles/form.module.scss';

const Loading: React.FC = () => {
  const logoSrc = useSelector(
    (state: StoreState) => state.branding.partnerLogoSrc || '',
  );

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <img alt='Logo' className={styles.logo} src={logoSrc} />
        <div className={styles.form}>
          <div className={styles.form_content}>
            <h2 className={styles.title_centered}>Loading...</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
